import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useT } from "@/context/LangContext";

export default function PaymentSuccess() {
  const t = useT();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "polling", payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setState({ status: "error" }); return; }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setState(data);
        if (data.payment_status === "paid" || data.status === "expired") return;
      } catch {}
      setAttempts((a) => a + 1);
      if (attempts < 8) setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  const paid = state.payment_status === "paid";
  const expired = state.status === "expired";

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="card-flat p-12 text-center max-w-md">
        {paid ? (
          <>
            <CheckCircle2 className="text-green-500 mx-auto" size={56} />
            <h1 className="font-display text-3xl font-black mt-6">{t("pay.success.title")}</h1>
            <p className="text-[var(--ink-soft)] mt-3">{t("pay.success.desc")}</p>
          </>
        ) : expired ? (
          <>
            <XCircle className="text-red-500 mx-auto" size={56} />
            <h1 className="font-display text-3xl font-black mt-6">{t("pay.expired.title")}</h1>
            <p className="text-[var(--ink-soft)] mt-3">{t("pay.expired.desc")}</p>
          </>
        ) : (
          <>
            <Loader2 className="animate-spin mx-auto text-[var(--accent)]" size={48} />
            <h1 className="font-display text-2xl font-bold mt-6">{t("pay.checking")}</h1>
          </>
        )}
        <button className="btn-primary mt-8" onClick={() => nav("/produits")} data-testid="back-products">{t("pay.back")}</button>
      </div>
    </div>
  );
}
